// extracted by mini-css-extract-plugin
export default {"cartItem":"CartItem_cartItem__u9LN+","lable":"CartItem_lable__86nxD","cartItemControles":"CartItem_cartItemControles__d-dj5"};